<aura-edit-wrapper
  [title]="'Avatar'"
  [(isEditing)]="isEditing"
  [showDivider]="true"
  (saved)="avatarSaved.emit($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <aura-person-avatar-form
      [dto]="initialAvatar()"
      [placeholder]="firstName()"
      [requiredFields]="['avatar']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-person-avatar-display [currentAvatar]="initialAvatar()" [placeholder]="firstName()" />
  }
</aura-edit-wrapper>
